import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useLingui } from '@lingui/react'
import { t } from '@lingui/macro'

import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material'
import CachedRoundedIcon from '@mui/icons-material/CachedRounded'

import SelectInputController from '@/components/ui/inputs/SelectInputController'

import { DMPConnectVitaleCardFormData } from '../model/useDMPConnectVitaleCardForm'
import { useGetVitaleCards } from '../model/useGetVitaleCards'

type SelectCardReaderProps = {
  disabled?: boolean
  newCardInserted?: boolean
}

/** Vitale card reader picker with a refresh action; re-lists readers when a new card is inserted. */
export function SelectCardReader({ disabled, newCardInserted }: SelectCardReaderProps) {
  useLingui()
  const rhForm = useFormContext<DMPConnectVitaleCardFormData>()
  const { isLoading, refetch, vitaleCards } = useGetVitaleCards()

  useEffect(() => {
    if (newCardInserted) {
      refetch()
    }
  }, [newCardInserted, refetch])

  return (
    <Box width="100%">
      <Box mt={1} width="100%" position="relative">
        <Tooltip placement="top" title={t`Refresh`}>
          <IconButton onClick={refetch} size="small" sx={{ position: 'absolute', top: '-2px', right: 0, zIndex: 1 }}>
            <CachedRoundedIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
        <SelectInputController
          control={rhForm.control}
          disabled={disabled}
          fullWidth
          label={t`Vitale card reader`}
          name="cardName"
          options={isLoading ? [] : vitaleCards}
          readOnly={isLoading}
        />
        {isLoading && (
          <Box position="absolute" top="75%" left="50%" sx={{ transform: 'translate(-50%, -50%)' }}>
            <CircularProgress size={20} />
          </Box>
        )}
      </Box>
    </Box>
  )
}
